import { Button } from '../../UI/Button'

interface GodziDropIconProps {
  isIconOpen: boolean
  isEnable: boolean
  onPress: () => void
}
export const GodziDropIcon = (props: GodziDropIconProps) => {
  if (!props.isIconOpen) return null

  return (
    <Button
      name="godzidrop icon"
      x={5}
      y={23}
      enabled={props.isEnable}
      visible={true}
      width={130}
      height={116}
      defaultView="btn_godzidrop_normal"
      hoverView="btn_godzidrop_hover"
      disabledView="btn_godzidrop_disable"
      pressedView="btn_godzidrop_pressed"
      onPress={props.onPress}
    />
  )
}
